import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=5343f8cc&scoped=true&"
import script from "./Icons.vue?vue&type=script&lang=ts&"
export * from "./Icons.vue?vue&type=script&lang=ts&"
import style0 from "./Icons.vue?vue&type=style&index=0&id=5343f8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5343f8cc",
  null
  
)

export default component.exports